export class CourseM{
  id:number = 0;
  no:string = '';
  status:string = '';
  name:string = '';
  price1:number = 0;
  price2:number = 0;
  teach_period:number = 0;
  teach_times:number = 0;
  total_price:number = 0;
  convenience_time:string = '';
  user:object = {};
  user_detail = [];
  detail:string = "";
  approved:boolean = false;
  firstname:string = "";
  lastname:string = "";
  avatar:string = "";
}



// WEBPACK FOOTER //
// ./src/app/model/course.model.ts